'use strict';

import FacebookModel from 'standard-vote/app/scripts/models/facebook.js';

module.exports = FacebookModel;



// WEBPACK FOOTER //
// ./app/scripts/models/facebook.js